import gameNames from 'a/hub/data/GameIds';

export const GAME_ID = gameNames.CUT_IT_OUT;
export const ACTIVITY_WINDOW = 'activity_window';
export const PROGRESS_WINDOW = 'progress_window';
export const ONBOARDING_WINDOW = 'onboarding_window';
export const INSTRUCTION_WINDOW = 'instruction_window';
export const LOADING_WINDOW = 'loading_window';
export const BONUS_GAME_WINDOW = 'bonus_game_window';
export const PRACTICE_WINDOW = 'practice_window';
export const NUM_QUESTIONS = 6; // for testing purposes
export const MASTER_CRITERIA = 5;
export const MASTER_CRITERIA_SPANISH = 4;
export const LEVEL_PLAYED_COUNTER = 18;
export const WORD_PARTS = {
  BEGINNING: 'beginning',
  MIDDLE: 'middle',
  ENDING: 'ending',
};

export const ONBOARDING_STAGES = {
  INSTRUCTION: 'INSTRUCTION',
  PRACTICE: 'PRACTICE',
};

// Alex states
export const ALEX_STATES = {
  INACTIVE: 0,
  ACTIVE: 1,
  SPEAKING: 2,
};
export const BITES_EARNED_PER_LEVEL = 3;
export const MODAL = {
  LEFT_ARROW: 'modal_left_arrow',
  RIGHT_ARROW: 'modal_right_arrow',
};

export const REDUX_ACTIONS = {
  SET_ACTIVITY_WINDOW: 'SET_ACTIVITY_WINDOW',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  SET_ALEX_ACTIVE: 'SET_ALEX_ACTIVE',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  LOAD_MODAL: 'LOAD_MODAL',
  INIT_BONUS_LEVEL: 'INIT_BONUS_LEVEL',
  SET_ANIMAL_HEAD: 'SET_ANIMAL_HEAD',
  SET_ANIMAL_BODY: 'SET_ANIMAL_BODY',
  SET_ANIMAL_TAIL: 'SET_ANIMAL_TAIL',
  SET_SELECTED_SECTION: 'SET_SELECTED_SECTION',
  SET_INTERACTION_LOCKED: 'SET_INTERACTION_LOCKED',
  SET_MODAL_VISIBLE: 'SET_MODAL_VISIBLE',
  SET_PULSING_TOKENS_COUNTER: 'SET_PULSING_TOKENS_COUNTER',
  SET_PICTURE_DRAGGED: 'SET_PICTURE_DRAGGED',
  INIT_DRAG_AND_DROP: 'INIT_DRAG_AND_DROP',
  SET_PICTURE_DROPPED: 'SET_PICTURE_DROPPED',
  SET_HIGHLIGHTED_PICTURE: 'SET_HIGHLIGHTED_PICTURE',
  SET_INSTRUCTION_PLAYING: 'SET_INSTRUCTION_PLAYING',
  INIT_ONBOARDING: 'INIT_ONBOARDING',
  SET_PULSING_PILL: 'SET_PULSING_PILL',
  SET_PULSE_FINISHED: 'SET_PULSE_FINISHED',
  SET_HIGHLIGHTED_PILL_LABEL: 'SET_HIGHLIGHTED_PILL_LABEL',
  SET_ACTIVE_PILL_LABEL: 'SET_ACTIVE_PILL_LABEL',
  SET_PLACEHOLDER_LAYOUT: 'SET_PLACEHOLDER_LAYOUT',
  SET_PLACEHOLDER_PICTURE: 'SET_PLACEHOLDER_PICTURE',
  SET_FEEDBACK_PICTURE: 'SET_FEEDBACK_PICTURE',
  INIT_PLACEHOLDER_PICTURE: 'INIT_PLACEHOLDER_PICTURE',
  INIT_PRACTICE: 'INIT_PRACTICE',
  REVEAL_PICTURE: 'REVEAL_PICTURE',
  SET_ACTIVE_PICTURE: 'SET_ACTIVE_PICTURE',
  INIT_REWARD_BOWL: 'INIT_REWARD_BOWL',
  SET_REWARD_BOWL_STATE: 'SET_REWARD_BOWL_STATE',
  SET_REWARD_BOWL_ANIMATION_STATE: 'SET_REWARD_BOWL_ANIMATION_STATE',
  INIT_ROUND: 'INIT_ROUND',
  NEXT_QUESTION: 'NEXT_QUESTION',
  INCREMENT_ANSWER_ATTEMPTS: 'INCREMENT_ANSWER_ATTEMPTS',
  SIMPLIFY_QUESTION: 'SIMPLIFY_QUESTION',
  INCREMENT_QUESTIONS_CORRECT: 'INCREMENT_QUESTIONS_CORRECT',
  INCREMENT_QUESTIONS_ANSWERED: 'INCREMENT_QUESTIONS_ANSWERED',
  SET_BONUS_LEVEL_TOKENS: 'SET_BONUS_LEVEL_TOKENS',
  SET_LAST_LEVEL_MASTERED: 'SET_LAST_LEVEL_MASTERED',
  SET_ZAPS_EARNED_PER_LEVEL: 'SET_ZAPS_EARNED_PER_LEVEL',
  SET_HAS_SEEN_ONBOARDING: 'SET_HAS_SEEN_ONBOARDING',
  INCREMENT_LEVEL_PLAYED_COUNTER: 'INCREMENT_LEVEL_PLAYED_COUNTER',
  INCREMENT_PRACTICE_PLAYED_COUNTER: 'INCREMENT_PRACTICE_PLAYED_COUNTER',
  DECREMENT_PRACTICE_TOKENS: 'DECREMENT_PRACTICE_TOKENS',
  ADD_CREATED_ANIMAL: 'ADD_CREATED_ANIMAL',
  SET_LEVEL_MASTERED: 'SET_LEVEL_MASTERED',
  INCREMENT_FIRST_ATTEMPT_ANSWERS: 'INCREMENT_FIRST_ATTEMPT_ANSWERS',
  SET_PULSING_SUBMIT_BUTTON: 'SET_PULSING_SUBMIT_BUTTON',
  INIT_BACKGROUNDS: 'INIT_BACKGROUNDS',
  SET_CURRENT_BACKGROUND: 'SET_CURRENT_BACKGROUND',
  INIT_ACCESSIBILITY: 'INIT_ACCESSIBILITY',
  SET_ACCESSIBILITY_GROUP: 'SET_ACCESSIBILITY_GROUP',
  SET_ONBOARDING_STAGE: 'SET_ONBOARDING_STAGE',
  SET_PLACEHOLDER_HIGHLIGHTED: 'SET_PLACEHOLDER_HIGHLIGHTED',
  SIMPLIFY_ONBOARDING_QUESTION: 'SIMPLIFY_ONBOARDING_QUESTION',
  SET_ONBOARDING_INTERACTION_LOCKED: 'SET_ONBOARDING_INTERACTION_LOCKED',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const NUM_STANDARD_BACKGROUNDS = 6;
